import React from "react";
import PropTypes from "prop-types";

const SimpleLink = ({ children, className, link }) => (
  <a
    href={link}
    className={className}
  >
    {children}
  </a>
);

SimpleLink.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  link: PropTypes.string,
};

SimpleLink.defaultProps = {
  link: ``,
};

SimpleLink.displayName = `SimpleLink`;

export default SimpleLink;
